import { useAuthStore } from 'store'
import { useProfileCacheStore } from 'store/profileCacheStore'
import type { IProfile } from 'types/interfaces/IProfile'

const toNum = (v: any): number | undefined => {
  const n = typeof v === 'string' ? Number(v) : typeof v === 'number' ? v : NaN
  return Number.isFinite(n) ? n : undefined
}

/**
 * Update the logged-in user's cached profile ONLY using values
 * explicitly returned by the backend.
 *
 * No optimistic math.
 * No fallbacks.
 */
export function updateProfileCacheFromResponse(response: any, userData: IProfile) {
  if (!userData?.username || !userData?.id) return

  const backend = response?.data ?? response

  // handle your actual response shape:
  // { status:"OK", code:200, data:{ status:200, message:"...", wallet_deposit, available_daily_limit } }
  // and also tolerate { data: { ... } } wrappers
  const data = backend?.data?.data ?? backend?.data ?? backend

  const wallet_deposit = toNum(data?.wallet_deposit)
  const available_daily_limit = toNum(data?.available_daily_limit)

  // hard rule: do nothing unless backend sent updated values
  if (wallet_deposit == null && available_daily_limit == null) return

  const patch = {
    ...(wallet_deposit != null ? { wallet_deposit } : {}),
    ...(available_daily_limit != null ? { available_daily_limit } : {}),
  }

  //
  // 1) Update AuthStore (TipModal uses useUserProfile() -> AuthStore.userProfile)
  //
  const auth = useAuthStore.getState()
  if (auth.userProfile) {
    auth.setUserProfile({
      ...(auth.userProfile as any),
      ...patch,
    })
  }

  //
  // 2) Update ProfileCacheStore (viewer-scoped cache)
  //
  const store = useProfileCacheStore.getState()
  const cached = store.getProfile(userData.username, userData.id)
  const base: IProfile = cached ?? userData

  store.setProfile(
    userData.username,
    {
      ...base,
      ...patch,
    } as any,
    userData.id
  )
}